import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Night.module.css";
const Night = () => {
  const navigate = useNavigate();

  const onRightSideMenuClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onToggleGroupClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <div className={styles.night}>
      <div className={styles.table} id="world-table">
        <div className={styles.row}>
          <div className={styles.cell}>
            <div className={styles.content}>
              <div className={styles.text}>Country</div>
            </div>
          </div>
          <div className={styles.cell}>
            <div className={styles.content}>
              <div className={styles.text}>Current Status</div>
            </div>
          </div>
          <div className={styles.cell2}>
            <div className={styles.content}>
              <div className={styles.text}>14 day volatility</div>
            </div>
          </div>
        </div>
        <div className={styles.row1}>
          <div className={styles.cell3}>
            <div className={styles.cell4}>
              <div className={styles.content3}>
                <div className={styles.text3}>Mali</div>
              </div>
            </div>
          </div>
          <div className={styles.cell5}>
            <div className={styles.content}>
              <div className={styles.text3}>Monitor sporadically</div>
            </div>
          </div>
          <div className={styles.npsgood}>
            <img className={styles.npsgoodChild} alt="" src="/vector-7.svg" />
            <div className={styles.comparison}>
              <img className={styles.heightIcon} alt="" src="/8height.svg" />
              <div className={styles.div}>12%</div>
            </div>
          </div>
        </div>
        <div className={styles.row2}>
          <div className={styles.cell5}>
            <div className={styles.content3}>
              <div className={styles.text3}>India</div>
            </div>
          </div>
          <div className={styles.cell5}>
            <div className={styles.content}>
              <div className={styles.text3}>Monitor closely</div>
            </div>
          </div>
          <div className={styles.npstype3}>
            <img className={styles.npstype3Child} alt="" src="/vector-6.svg" />
            <div className={styles.comparison1}>
              <img className={styles.heightIcon} alt="" src="/8height1.svg" />
              <div className={styles.div}>3%</div>
            </div>
          </div>
        </div>
        <div className={styles.row1}>
          <div className={styles.cell5}>
            <div className={styles.content3}>
              <div className={styles.text3}>Ukraine</div>
            </div>
          </div>
          <div className={styles.cell5}>
            <div className={styles.content}>
              <div className={styles.text3}>Extreme risk</div>
            </div>
          </div>
          <div className={styles.npstype31}>
            <img className={styles.npstype3Item} alt="" src="/vector-61.svg" />
            <div className={styles.comparison1}>
              <img className={styles.heightIcon} alt="" src="/8fall1.svg" />
              <div className={styles.div}>27%</div>
            </div>
          </div>
        </div>
        <div className={styles.row4}>
          <div className={styles.cell10}>
            <div className={styles.content}>
              <div className={styles.text3}>United States</div>
            </div>
          </div>
          <div className={styles.cell5}>
            <div className={styles.content}>
              <div className={styles.text3}>High risk</div>
            </div>
          </div>
          <div className={styles.npstype31}>
            <img className={styles.smilebadIcon} alt="" />
            <img className={styles.npstype3Item} alt="" src="/vector-61.svg" />
            <div className={styles.comparison1}>
              <img className={styles.heightIcon} alt="" src="/8fall1.svg" />
              <div className={styles.div}>12%</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.topCountriesTo}>Top Countries to Watch</div>
      <div className={styles.world} id="world-map">
        <img className={styles.worldChild} alt="" src="/rectangle-41.svg" />
        <img className={styles.worldIcon} alt="" src="/world1.svg" />
      </div>
      <div className={styles.navbar} id="nav-bar">
        <div className={styles.pageNameBreadcrumb}>
          <a className={styles.globalHeatmap}>Global Heatmap</a>
          <div className={styles.breadcumb}>
            <a className={styles.delphi}>DELPHI</a>
            <div className={styles.div4}>{`>`}</div>
            <a className={styles.delphi}>Dashboard</a>
          </div>
        </div>
        <input
          className={styles.searchBar}
          type="text"
          placeholder="Jump to country profile"
        />
        <div className={styles.rightSideMenu} onClick={onRightSideMenuClick}>
          <button className={styles.toggleGroup} onClick={onToggleGroupClick}>
            <img className={styles.worldIcon} alt="" src="/toggle.svg" />
          </button>
          <button className={styles.userInformation}>
            <div className={styles.profilePictName}>
              <img
                className={styles.profilePictureIcon}
                alt=""
                src="/profile-picture@2x.png"
              />
              <div className={styles.userNameEmail}>
                <div className={styles.gabrielValente}>Gabriel Valente</div>
                <div className={styles.gabrielgeopolitica}>
                  gabriel@geopoliti.ca
                </div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Night;
